<div class="basket {{ paymentClass }}" *ngIf="order != null && orderLines != null && orderLines.length > 0">
    <div class="basket-header">
        <div class="basket-header-title">
            <div class="basket-header-title-cell" *ngIf="paymentModel === 1">
                <h4 class="left" *ngIf="navigateCheckout">Din chance</h4>
                <h4 *ngIf="paymentDetailsVisible">Din chance</h4>
            </div>
            <div class="basket-header-title-cell" *ngIf="paymentModel === 2">
                <h4>Spil med allerede i {{drawDateFirst | date : "MMMM"}}</h4>
            </div>
            <div class="basket-header-title-cell clearfix" *ngIf="navigateCheckout">
                <p class="text-end float-end" (click)="close()">Minimer kurv <span
                        class="float-end minimize"></span></p>
            </div>
        </div>
        <div class="basket-header-game">
            <div class="row">
                <div class="basket-header-game-winrates col-12">
                    <div class="row">
                        <!-- <hr class="w-100"> -->
                        <div class="col-6 winrate" [ngClass]="{ 'winrate--checkout': navigateCheckout }">
                            <div class="winrate-cell">
                                <div class="caption">
                                    Mulig topgevinst
                                </div>
                                <div class="number" [innerHtml]="topPrize | money"></div>
                            </div>
                        </div>
                        <div class="col-6 winrate" [ngClass]="{ 'winrate--checkout': navigateCheckout }">
                            <div class="winrate-cell">
                                <div class="caption">
                                    Årlig vinderchance
                                </div>
                                <div class="number" [innerHtml]="winChance | percent : null : 'en'"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="orderline">
            <h5 class="orderline-title">Du har valgt følgende</h5>
            <hr class="w-100">
            <div class="orderline-scroll">
                <div *ngFor="let orderLine of packageOrderLines; let i = index" class="orderline-container">
                    <div class="row removable"
                        [ngClass]="{ 'deleting': (pendingDeleteItem != null && pendingDeleteItem == orderLine.items[0]) }">
                        <div class="orderline-container-small col-5">
                            <span class="orderline-container-number">{{ orderLine.items.length }}</span><span
                                class="orderline-container-super"> X </span>
                            <div
                                class='orderline-container-icon orderline-container-icon-package orderline-container-icon-package--{{ ("global_package_primary_name_" + orderLine.name) | resource }}'>
                            </div>
                        </div>
                        <div class="orderline-container-info col-7 mt-2 mb-2">
                            <div class="padding-right row">
                                <div class="col-12">
                                    <div class="title float-start">
                                        {{ ("global_package_primary_name_" + orderLine.name) | resource }}
                                    </div>
                                    <div *ngIf="locked === false && !checkoutState" class="float-end remove"
                                        (click)="deleteOrderItemPackage(orderLine.items[0])"></div>
                                </div>
                                <div class="col-12">
                                    Årlig vinderchance: {{ orderLine.winChance | percent : null : "en" }}
                                </div>
                                <div class="col-12">
                                    Topgevinst: {{ orderLine.topPrize | money }}
                                </div>
                                <div class="col-12 mt-1 mb-1">
                                    <div>{{ ("global_package_primary_name_" + orderLine.name) | resource }} indeholder:
                                    </div>
                                    <div *ngFor="let shareGroup of orderLine.shareGroupList">
                                        {{ shareGroup.shares.length }} x
                                        {{ 'global_share_type_name_' + shareGroup.name | resource }}
                                    </div>
                                </div>
                                <div class="col-12 orderline-price">
                                    Pris pr. {{ classCount === 6 ? "halvår" : "måned" }}
                                    {{ (classCount === 6 ? orderLine.price.subscriptionSixMonths : orderLine.price.subscriptionSingleMonth) | money }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="divider" *ngIf="i < packageOrderLines.length - 1 || shareOrderLines.length > 0" />
                </div>

                <div *ngFor="let orderLine of shareOrderLines; let i = index" class="orderline-container">
                    <div class="row">
                        <div class="orderline-container-small col-5">
                            <span class="orderline-container-number">{{ orderLine.items.length }}</span><span
                                class="orderline-container-super"> X </span>
                            <div
                                class='orderline-container-icon orderline-container-icon-ticket orderline-container-icon-ticket--{{ ("global_ticket_normalized_name_" + orderLine.items[0].share.Type.Size) | resource }}'>
                            </div>
                        </div>
                        <div class="orderline-container-info col-7 mt-2 mb-2">
                            <div class="padding-right row">
                                <div class="col-12">
                                    <div class="title float-start">
                                        {{ ("global_share_type_name_" + orderLine.name) | resource }}
                                    </div>
                                    <div *ngIf="orderLine.items.length === 1 && !checkoutState" class="float-end remove"
                                        (click)="deleteOrderItemShare(orderLine.items[0].share)"></div>
                                </div>
                                <div class="col-12">
                                    Topgevinst: {{ stringToNumber("global_share_type_top_prize_" + orderLine.name | resource) | money }}
                                </div>
                                <div class="col-12 removable" *ngFor="let item of orderLine.items"
                                    [ngClass]="{'deleting': (pendingDeleteItem == item.share) }">
                                    <span title="Ønskelod" class="dreamticket-icon"
                                        *ngIf="item.isDreamTicket === true"></span> Lodnr:
                                    {{ item.share.Ticket.TicketNumber | number }} {{ item.share.Name }}
                                    <span *ngIf="orderLine.items.length > 1" class="remove remove-small"
                                        (click)="deleteOrderItemShare(item.share)"></span>
                                </div>
                                <div class="col-12 orderline-price mt-1">
                                    Pris pr. {{ classCount === 6 ? "halvår" : "måned" }}
                                    {{ (classCount === 6 ? orderLine.price.subscriptionSixMonths : orderLine.price.subscriptionSingleMonth) | money }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="divider" *ngIf="i < shareOrderLines.length - 1" />
                </div>
            </div>

            <div class="price">
                <div class="total-amount">
                    <p class="total-amount-text">I alt at betale</p>
                    <ng-container *ngIf="isBsAppActive">
                        <p class="total-amount-value"
                            [innerHtml]="priceTotal + pricePrMonth + (fees != null && fees.length > 0 ? fees[0].value : 0) | money">
                        </p>
                    </ng-container>
                    <ng-container *ngIf="!isBsAppActive">
                        <p class="total-amount-value"
                            [innerHtml]="priceTotal + (fees != null && fees.length > 0 ? fees[0].value : 0) | money">
                        </p>
                    </ng-container>
                </div>
                <span class="total-amount-one" *ngIf="classCount === 6 && !isBsAppActive ">&#40;{{ pricePrMonth | money}} pr. md&#41;</span>
                <div *ngIf="fees.length > 0" class="fees">
                    <p class="fees-text">Gebyrer udgør heraf</p>
                    <p class="fees-value">{{ fees[0].value | money }}</p>
                </div>
                <div *ngIf="isBsAppActive" class="fees-text">
                    <p>(+tilkøb af {{ drawDateFirst | date : "MMMM" }})</p>
                </div>
                <div *ngIf="classCount > 1 && priceChangeInEffect" class="pricing-update-link">
                    <a (click)="onPricingDetailsClick()" [ngClass]="{ 'disabled': pricingUpdateExpanded }">Sådan beregnes prisen</a>
                </div>
            </div>
        </div>
    </div>

    <div class="pricing-update" *ngIf="classCount > 1 && priceChangeInEffect" [ngClass]="{'expanded': pricingUpdateExpanded}">
        <app-pricing-update #pricingUpdate [order]="order" [expanded]="pricingUpdateExpanded" (onExpand)="onPricingExpand()"></app-pricing-update>
    </div>

    <div *ngIf="!playerLoggedIn">
        <button class="cta cta--primary mb-4" routerLink="/betaling/om-dig" [disabled]="disabled"
            (click)="animateButtonMobile()" *ngIf="navigateCheckout">
            Gå til betaling
        </button>
    </div>
    <div *ngIf="playerLoggedIn">
        <button class="cta cta--primary mb-4" (click)="onPaymentClicked()">
            Gå til Min side
        </button>
    </div>

    <div class="payment-details pt-2" *ngIf="paymentDetailsVisible">
        <div class="payment-details-cover">
            <ng-container *ngIf="classCount === 6 || isBsAppActive">
                Betalingen dækker over trækninger fra<br> <span>{{ drawDateFirst | date : "MMMM yyyy" }}</span> til og
                med <span>{{ drawDateLast | date : "MMMM yyyy" }}</span>
            </ng-container>
            <ng-container *ngIf="classCount === 1 && !isBsAppActive">
                Betalingen dækker over trækningen i <span>{{ drawDateFirst | date : "MMMM yyyy" }}</span>
            </ng-container>
        </div>

        <app-playing-months [checkoutState]="checkoutState"></app-playing-months>

        <div class="win-note d-none d-xl-block mt-xl-3">
            <p>Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.</p>
        </div>
    </div>
    <div *ngIf="classCount === 1 && paymentDetailsVisible && priceChangeInEffect" class="pricing-update expanded mt-2">
        <div class="pricing-update-content">
            <strong>Nye priser fra 2022</strong>
            <p>
                Lodpriserne justeres fra april 2022.
            </p>
            <strong><a (click)="onShowPriceUpdateInfoClick()">Læs mere her</a></strong>
        </div>
    </div>
</div>
